(function () {
  function fixMediaHeight() {
    if (window.innerWidth < 750 || window.innerWidth > 991) return;
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      var width = item.getBoundingClientRect().width;
      if (width > 0 && item.style.height !== width + 'px') {
        item.style.setProperty('height', width + 'px', 'important');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixMediaHeight);
  window.addEventListener('resize', fixMediaHeight);

  // Surveille en continu la galerie et réapplique le correctif si un script tiers la modifie
  var list = document.querySelector('.product__media-list');
  if (list) {
    var observer = new MutationObserver(function () {
      fixMediaHeight();
    });
    observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  fixMediaHeight();
})();